import { GridColumn } from 'types/grid';
import { Status } from 'types/status';

import { scheduleGridFilter } from 'pages/ScheduleContact/utils';
import { ContactGridData } from './types';

export const contactGridColumns: GridColumn[] = [
  { title: 'Spacecraft', key: 'linkName', width: 160 },
  { title: 'Ground Station', key: 'contactProfileName', width: 180 },
  { title: 'Start Time', key: 'startTime', width: 180 },
  { title: 'End Time', key: 'endTime', width: 180 },
  { title: 'Available time', key: 'availableTime', width: 130 },
  { title: 'Highest Altitude (Degree)', key: 'MaxElevation', width: 140 },
  { title: 'Status', key: 'statusName', width: 130 },
  { title: 'Payment', key: 'isPayment',width: 130 },
  { title: 'Cancel', key: 'cancelable',width: 130 },
  { title: 'Cancel Status', key: 'cancelStatus',width: 140 },
];

export const contactGridStatus: Record<string, Status> = {
  Idle: { title: 'Idle', className: 'bg-white border-black text-black'},
  Done: { title: 'Done', className: 'bg-[#DBF8E3] border-[#028E08] text-[#05870A]' },
  Scheduled: { title: 'Scheduled', className: 'bg-[#E6F2FE] border-[#0890F3] text-[#0890F3]' },
  Progress: { title: 'In Progress', className: 'bg-[#E6FEED] border-[#27B72D] text-[#27B72D]' },
  Cancel: { title: 'Cancel', className: 'bg-white border-#8F8F8F text-#8F8F8F' },
  Fail: { title: 'Fail', className: 'bg-[#FEE6E6] border-[#F30808] text-[#F30808]' },
  Unknown: { title: 'Unknown', className: 'bg-white border-#8F8F8F text-#8F8F8F' },
};

export const paymentStatus: Record<string, Status> = {
  paymentCompleted: { title: 'Complete', className: 'bg-[#E6FEED] border-[#27B72D] text-[#27B72D]' },
  paymentPending: { title: 'Pending', className: 'bg-[#E6F2FE] border-[#0890F3] text-[#0890F3]' },
}

export const cancelStatus: Record<string, Status> = {
  // 기존 매핑 유지
  Cancel: { title: 'Cancel', className: 'bg-[#FEE6E6] border-[#F30808] text-[#F30808]' },
  Toberefunded: { title: 'To be refunded', className: 'bg-white border-[#8F8F8F] text-[#8F8F8F]' },
  Refunded: { title: 'Refunded', className: 'bg-white border-[#8F8F8F] text-[#8F8F8F]' },
  None: { title: 'None', className: 'bg-white border-[#8F8F8F] text-[#8F8F8F]' },
  
  // 백엔드 ENUM 값들 추가 (POSTMAN 확인된 값들)
  'NONE': { title: 'None', className: 'bg-white border-[#8F8F8F] text-[#8F8F8F]' },
  'CANCEL': { title: 'Cancel', className: 'bg-[#FEE6E6] border-[#F30808] text-[#F30808]' },
  'TO_BE_REFUNDED': { title: 'To be refunded', className: 'bg-[#FFF4E6] border-[#F39C08] text-[#F39C08]' },
  'REFUNDED': { title: 'Refunded', className: 'bg-[#E6FEED] border-[#27B72D] text-[#27B72D]' },
};


export const cancelable: Record<string, Status> = {
  Cancel: { title: 'Cancel', className: 'bg-[#FEE6E6] border-[#F30808] text-[#F30808]' },
};
